import styled from 'styled-components'

const StyledPhotoSectionCol = styled.div`
   
`
export default StyledPhotoSectionCol;


